// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import React, { HTMLAttributes, useMemo } from "react";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;

import XtSvg from "../components/xt/svg";
import SvgCorrect from "../svg/correct";

import styles from "./index.module.scss";
import stylesCommon from "../common.module.scss";

// import imgPasskey from "./passkey.svg";
// import imgEmail from "./email.svg";
// import imgMobile from "./mobile.svg";
// import imgGoogle from "./google.svg";

import ImgPasskey from "./passkey";
import ImgEmail from "./email";
import ImgMobile from "./mobile";
import ImgGoogle from "./google";

export enum VerifyTypeEnum {
  passkey = "passkey", //通行密钥验证
  email = "email", //邮箱验证
  mobile = "mobile", //手机验证
  google = "google", //谷歌验证
}

interface Props extends HTMLAttributes<HTMLButtonElement> {
  type: VerifyTypeEnum;
  arrow?: boolean;
  arrowSuccess?: boolean;
  desc?: boolean | string;
}

const Main: React.FC<Props> = ({ type, arrow, arrowSuccess, desc, className, ...rest }) => {
  const t = useTranslation();

  const getPorps = useMemo(() => {
    return {
      src: (() => {
        const obj = {
          [VerifyTypeEnum.passkey]: <ImgPasskey/>,
          [VerifyTypeEnum.email]: <ImgEmail/>,
          [VerifyTypeEnum.mobile]: <ImgMobile/>,
          [VerifyTypeEnum.google]: <ImgGoogle/>,
        };
        return obj[type];
      })(),
      label: (() => {
        const obj = {
          [VerifyTypeEnum.passkey]: t("@xt/Passkey.passkey"),
          [VerifyTypeEnum.email]: t("@xt/Passkey.email"),
          [VerifyTypeEnum.mobile]: t("@xt/Passkey.mobile"),
          [VerifyTypeEnum.google]: t("@xt/Passkey.GoogleAuthenticator"),
        };
        return obj[type];
      })(),
      desc: (() => {
        if (!desc) return "";
        if (typeof desc === "string") return desc;
        const obj = {
          [VerifyTypeEnum.passkey]: t("@xt/Passkey.passkeyVerifyDesc"),
          [VerifyTypeEnum.email]: "",
          [VerifyTypeEnum.mobile]: "",
          [VerifyTypeEnum.google]: "",
        };
        return obj[type];
      })(),
    };
  }, [type, desc]);

  return (
    <button className={cx(stylesCommon.btnTxt, styles.main, className)} disabled={arrow && arrowSuccess} {...rest}>
      {/*<img className={styles.logo} src={getPorps.src} alt={getPorps.label} />*/}
      {getPorps.src}
      <div className={styles.content}>
        <div>{getPorps.label}</div>
        {!!getPorps.desc && <p>{getPorps.desc}</p>}
      </div>

      {arrow && (
        <div className={styles.arrDiv}>
          {arrowSuccess ? (
            <SvgCorrect />
          ) : (
            <div>
              <span>➔</span>
            </div>
          )}
        </div>
      )}
    </button>
  );
};

export default Main;
